import { style } from "@vanilla-extract/css";

export const graphControls = style({
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  padding: "0.5rem 1rem"
});

export const dimensionSelect = style({
  width: "180px"
});

export const stackedTitleStyle = style({
  textAlign: "center",
  fontSize: "14px",
  fontWeight: 600,
  padding: "0.5rem 0"
});

export const stackedNoteWrapper = style({
  display: "flex",
  justifyContent: "center",
  padding: "0.5rem 0"
});
